import { render, staticRenderFns } from "./DiseaseNew.vue?vue&type=template&id=4a012344&scoped=true&"
import script from "./DiseaseNew.vue?vue&type=script&lang=js&"
export * from "./DiseaseNew.vue?vue&type=script&lang=js&"
import style0 from "./DiseaseNew.vue?vue&type=style&index=0&id=4a012344&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a012344",
  null
  
)

export default component.exports